const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const OpsUser = require("../../core/vault/OpsUser");

const OrderSummary = require("./OrderSummary");
const Input = require("./Input");
const CopyTable = require("../data/CopyTable");
const CoreCopy = require("../../core/util/CopyTable");
const Checkbox = require("../../core/view/Checkbox");
const LoadingCircle = require("../../core/view/LoadingCircle");
const {
	addDevTestingShortcutHandler,
} = require("../../core/util/setupDevTestingShortcut");
const {track} = require("../../core/util/Mixpanel");
const styles = require("./styles/CreateAccount.css");
const {FLAGS} = require("../../../shared/GlobalFlags");
const {getInputError} = require("../../../shared/StoreUtil");
const {getEmailTypoSuggestion} = require("../../../shared/emailTypoSuggestion");
const {X} = require("lucide-react");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	Component = withAnimateScroll(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CreateAccount",

		propTypes: {
			className: PT.string,
			cart: PT.object.isRequired,
			user: PT.object.isRequired,
			onContinue: PT.func,
			formOnly: PT.bool,
			createAccountCopyOverride: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateScroll: PT.func.isRequired,
		},

		vaultEvents: {
			verifyNewAccountNotReady: function() {
				this.setState({isLoading: false});
			},
			accountAlreadyExists: function() {
				this.setState({accountExists: true, isLoading: false});
			},
			verifyNewAccountFail: function() {
				this.setState({isLoading: false});
			},
		},

		getInitialState: function() {
			this.alreadyScrolledToError = true;
			const accountVerified = this.props.cart.accountVerified;
			const isNewAccount = !OpsUser.isLoggedIn(this.props.user);
			let firstName = "";
			let lastName = "";
			if (!isNewAccount) {
				const accountInfo = OpsCart.getFormSection(this.props.cart, "account");
				firstName = accountInfo.firstName;
				lastName = accountInfo.lastName;
			}

			return {
				isNewAccount: isNewAccount,
				hasSubmitted: false,
				acceptedTerms: accountVerified,
				acceptedCoppa: accountVerified,
				accountExists: false,
				isEditable: !accountVerified,
				isLoading: false,
				extraLoading: false,
				confirmType: false,
				firstName,
				lastName,
				emailTypoDismissed: false,
				emailTypoSuggestion: null,
			};
		},

		componentDidMount: function() {
			this.teardown = addDevTestingShortcutHandler(() => {
				this.setState({acceptedTerms: true, acceptedCoppa: true});
			});
		},

		componentWillUnmount: function() {
			this.teardown();
		},

		componentDidUpdate: function(prevProps) {
			if (
				!OpsUser.isLoggedIn(prevProps.user) &&
				OpsUser.isLoggedIn(this.props.user)
			) {
				this.setState({isNewAccount: false});
			}
			if (this.alreadyScrolledToError) return;
			const allAccepted = this.state.acceptedTerms && this.state.acceptedCoppa;
			if (this.state.hasSubmitted && !allAccepted && this.terms) {
				this.alreadyScrolledToError = true;
				this.props.animateScroll({
					scrollThing: this.terms,
					timeRatio: 0.65,
					maxTime: 1000,
				});
			}
		},

		// This mutates validation and returns it.
		augmentValidationWithAccept: function(validation, acceptKey) {
			if (!this.state[acceptKey]) {
				validation.isComplete = false;
				validation.missing.push(acceptKey);
				validation.errorTypes[acceptKey] = {type: "E_MISSING"};
			} else if (acceptKey === "phone") {
				const phoneError = getInputError("phone", this.state[acceptKey]);
				if (phoneError) {
					validation.isComplete = false;
					validation.errorTypes[acceptKey] = {type: phoneError.type};
				} else {
					_.pull(validation.missing, acceptKey);
					delete validation.errorTypes[acceptKey];
				}
			} else {
				_.pull(validation.missing, acceptKey);
				delete validation.errorTypes[acceptKey];
			}
			return validation;
		},

		getValidation: function() {
			const {cart, user} = this.props;
			let validation = OpsCart.checkFormSection(cart, "account");
			validation = _.cloneDeep(validation);
			const isNewAccount = !OpsUser.isLoggedIn(user);
			if (!isNewAccount) {
				// Fake the validation.
				// TODO: Maybe better in OpsCart or OpsCheckoutForm?
				validation = {
					missing: [],
					invalid: [],
					errorTypes: {},
					isComplete: true,
				};
			}
			validation = this.augmentValidationWithAccept(
				validation,
				"acceptedTerms"
			);
			validation = this.augmentValidationWithAccept(
				validation,
				"acceptedCoppa"
			);

			// Returning users don't need to collect name or phone during this flow.
			if (isNewAccount) {
				validation = this.augmentValidationWithAccept(validation, "phone");
				validation = this.augmentValidationWithAccept(validation, "firstName");
				validation = this.augmentValidationWithAccept(validation, "lastName");
			}

			if (!this.state.hasSubmitted) {
				validation.missing = [];
			}
			_.each(validation.errorTypes, (f, key) => {
				// Unset missing in errorTypes if not in missing fields
				if (f.type === "E_MISSING" && !_.includes(validation.missing, key)) {
					f.type = "";
				} else if (!f.type && _.includes(validation.missing, key)) {
					f.type = "E_MISSING";
				}
			});
			return validation;
		},

		updateField: function(field, val) {
			if (field === "email") {
				this.setState({
					accountExists: false,
					emailTypoDismissed: false,
					emailTypoSuggestion: null,
				});
			}
			if (field === "firstName" || field === "lastName") {
				this.setState({[field]: val});
			}
			if (field === "phone") {
				this.setState({phone: val});
				this.props.dispatch({
					type: AT.UPDATE_CART_FORMDATA,
					section: "contact",
					vals: {[field]: val},
				});
			}

			this.props.dispatch({
				type: AT.UPDATE_CART_FORMDATA,
				section: "account",
				vals: {[field]: val},
			});
		},

		toggleAcceptTerms: function() {
			this.setState({acceptedTerms: !this.state.acceptedTerms});
		},

		toggleAcceptCoppa: function() {
			this.setState({acceptedCoppa: !this.state.acceptedCoppa});
		},

		makeEditable: function() {
			const accountInfo = OpsCart.getFormSection(this.props.cart, "account");
			this.setState({isEditable: true});
			this.setState({firstName: accountInfo.firstName});
			this.setState({lastName: accountInfo.lastName});
			this.setState({phone: accountInfo.phone});
		},

		onContinue: function() {
			// Throttling done to fix T11411.
			this.doSubmit =
				this.doSubmit ||
				_.throttle(
					() => {
						const cart = this.props.cart;
						const validation = this.getValidation();
						this.setState({
							hasSubmitted: true,
							accountExists: false,
						});

						if (validation.isComplete) {
							if (this.state.isNewAccount) {
								this.setState({isLoading: true});
								this.props.dispatch(OpsCart.getAccountFinishingAction(cart));
							} else {
								// if formOnly, then redeem subscription flow, which needs special emit event.
								this.props.dispatch({
									type: AT.USE_PLATFORM_ACCOUNT,
									emitEvent: !!this.props.formOnly,
								});
							}
						} else {
							this.alreadyScrolledToError = false;
							this.props.dispatch({type: AT.SHOW_ALL_CHECKOUT_VALIDATION});
						}
					},
					500,
					{leading: true, trailing: false}
				);
			this.doSubmit();
		},

		validateOnly: function() {
			const validation = this.getValidation();
			this.setState({
				hasSubmitted: true,
				accountExists: false,
			});
			if (validation.isComplete) {
				this.setState({isLoading: true});
				this.props.onContinue();
			} else {
				this.alreadyScrolledToError = false;
				this.props.dispatch({
					type: AT.SHOW_ALL_CHECKOUT_VALIDATION,
					step: "account",
				});
			}
		},

		startLogin: function() {
			track("Login from Checkout - Create Account Step ");
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		startLogout: function() {
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				forSwitch: true,
			});
		},

		onEmailBlur: function(trimmedEmail) {
			this.setState({
				emailTypoSuggestion: getEmailTypoSuggestion(trimmedEmail),
			});
		},

		dismissEmailTypo: function() {
			this.setState({emailTypoDismissed: true});
		},

		applyEmailTypoSuggestion: function(full) {
			this.updateField("email", full);
			this.setState({emailTypoDismissed: true});
		},

		renderEmailTypoSlot: function() {
			const suggestion = this.state.emailTypoSuggestion;
			const show = !this.state.emailTypoDismissed && suggestion;
			if (!show) {
				return null;
			}
			return (
				<div className={styles.emailTypoSlot}>
					<div className={styles.emailTypoHintOuter}>
						<div
							className={styles.emailTypoHint}
							role="status"
							aria-live="polite"
						>
							<span className={styles.emailTypoLine}>
								<span className={styles.emailTypoPrefix}>
									{"Did you mean: "}
								</span>
								<button
									type="button"
									className={styles.emailTypoSuggested}
									onClick={() => this.applyEmailTypoSuggestion(suggestion.full)}
								>
									{suggestion.full}
								</button>
								<span className={styles.emailTypoSuffix}>{"?"}</span>
							</span>
							<button
								type="button"
								className={styles.emailTypoDismiss}
								onClick={this.dismissEmailTypo}
								aria-label="Dismiss email suggestion"
							>
								<X aria-hidden size={18} strokeWidth={2} />
							</button>
						</div>
					</div>
				</div>
			);
		},

		renderAcceptError: function(validation, acceptKey) {
			let errorClass = styles.errorTextHidden;
			if (validation.missing.indexOf(acceptKey) > -1) {
				errorClass = styles.errorText;
			}
			return (
				<div className={errorClass}>
					{"* " + CopyTable.getFormErrorCopy()["E_MISSING"]}
				</div>
			);
		},

		render: function() {
			const {
				isNewAccount,
				acceptedTerms,
				acceptedCoppa,
				isEditable,
			} = this.state;
			const {formOnly} = this.props;
			const validation = this.getValidation();
			const accountInfo = OpsCart.getFormSection(this.props.cart, "account");

			const errorFields = _.pick(validation, [
				"missing",
				"invalid",
				"errorTypes",
			]);
			const showError =
				_.some(errorFields.errorTypes, f => f.type) || this.state.accountExists;

			let mainTitle;
			let buttonAction;
			let emailEl = null;
			let firstNameEl = null;
			let lastNameEl = null;
			let phoneEl = null;
			let passwordEl = null;
			let repeatPasswordEl = null;
			let switchTop = null;
			let switchTopSmall = null;
			let errorEl;

			const acceptEl = (
				<div className={styles.accept} ref={t => (this.terms = t)}>
					<Checkbox
						className={styles.accept}
						text={CopyTable.getAcceptTermsCopy(styles)}
						onClick={this.toggleAcceptTerms}
						isSelected={acceptedTerms}
						isErrored={validation.missing.indexOf("acceptedTerms") > -1}
						noTextHover={true}
						disabled={!isEditable}
						tabIndex={0}
					/>
					{this.renderAcceptError(validation, "acceptedTerms")}
					<Checkbox
						className={styles.accept}
						text={CopyTable.getAcceptCoppaCopy()}
						onClick={this.toggleAcceptCoppa}
						isSelected={acceptedCoppa}
						isErrored={validation.missing.indexOf("acceptedCoppa") > -1}
						noTextHover={true}
						disabled={!isEditable}
						tabIndex={0}
					/>
					{this.renderAcceptError(validation, "acceptedCoppa")}
				</div>
			);

			if (isNewAccount) {
				const passwordError = _.get(errorFields.errorTypes, "password.type");
				const emailError = _.get(errorFields.errorTypes, "email.type");
				const firstNameError = _.get(errorFields.errorTypes, "firstName.type");
				const lastNameError = _.get(errorFields.errorTypes, "lastName.type");
				const phoneError = _.get(errorFields.errorTypes, "phone.type");
				const repeatPasswordError = _.get(
					errorFields.errorTypes,
					"passwordRepeat.type"
				);
				firstNameEl = (
					<Input
						className={styles.input}
						initialValue={accountInfo.firstName}
						placeholder={"First name"}
						onUpdate={val => this.updateField("firstName", val)}
						nameAttr={"firstName"}
						showErrorType={firstNameError}
						tabIndex={0}
					/>
				);
				lastNameEl = (
					<Input
						className={styles.input}
						initialValue={accountInfo.lastName}
						placeholder={"Last name"}
						onUpdate={val => this.updateField("lastName", val)}
						nameAttr={"lastName"}
						showErrorType={lastNameError}
						tabIndex={0}
					/>
				);

				phoneEl = (
					<Input
						className={styles.input}
						initialValue={accountInfo.phone}
						autocompleteAttr="section-contact tel"
						onUpdate={val => this.updateField("phone", val)}
						placeholder={"Phone Number"}
						checkType={"phone"}
						showErrorType={phoneError}
						maxLength={64}
					/>
				);

				emailEl = (
					<div className={styles.emailFieldBlock}>
						<Input
							className={styles.input}
							initialValue={accountInfo.email}
							placeholder={`Email${
								FLAGS.enableDevTestingShortcut
									? " (Dev: Ctrl-Alt-Cmd-0 to autofill)"
									: ""
							}`}
							onUpdate={val => this.updateField("email", val)}
							nameAttr={"email"}
							autocompleteAttr={"email"}
							showErrorType={emailError}
							checkType={"email"}
							tabIndex={0}
							onBlur={this.onEmailBlur}
						/>
						{this.renderEmailTypoSlot()}
					</div>
				);
				passwordEl = (
					<Input
						className={styles.input}
						inputType={"password"}
						initialValue={accountInfo.password}
						placeholder={"Enter password"}
						onUpdate={val => this.updateField("password", val)}
						nameAttr={"password"}
						showErrorType={passwordError}
						staticLabel={CoreCopy.passwordRuleCopy}
						checkType={"password"}
						tabIndex={0}
					/>
				);
				repeatPasswordEl = (
					<Input
						className={styles.input}
						inputType={"password"}
						initialValue={accountInfo.passwordRepeat}
						placeholder={"Re-enter password"}
						onUpdate={val => this.updateField("passwordRepeat", val)}
						nameAttr={"passwordRepeat"}
						checkType={"passwordRepeat"}
						showErrorType={repeatPasswordError}
						tabIndex={0}
					/>
				);

				if (!formOnly)
					mainTitle = (
						<span>
							Create Your <br className={styles.titleBreak} />
							Parent Account
						</span>
					);
				buttonAction = this.onContinue;
				switchTop = (
					<div className={styles.switchTop}>
						{"Already have a Parent Account?"}{" "}
						<span
							className={styles.switchTopLink}
							onClick={this.startLogin}
							tabIndex={0}
						>
							{"Sign in here."}
						</span>
					</div>
				);

				if (this.state.accountExists) {
					const replaceEl = (
						<div className={styles.switchTop} onClick={this.startLogin}>
							<div className={styles.red}>
								{"This account already exists. "}
								<span className={styles.redLink}>
									{"Click here to sign in."}
								</span>
							</div>
						</div>
					);
					if (formOnly) {
						errorEl = replaceEl;
					} else {
						switchTop = replaceEl;
					}
				}
			} else if (!isNewAccount) {
				buttonAction = this.onContinue;
				mainTitle = "Confirm Parent Account";
				switchTopSmall = (
					<div className={styles.switchTopSmall} onClick={this.startLogout}>
						Want to use a different account? Click here to sign out.
					</div>
				);
			} else {
				mainTitle = "Sign In";
			}

			const buttonText = this.state.isLoading ? (
				<div className={styles.loading}>
					<LoadingCircle colorType="white" />
				</div>
			) : (
				"Continue"
			);

			let content;

			if (!isEditable && isNewAccount) {
				// User just signed up for the account
				content = (
					<div className={styles.form}>
						<div className={styles.fieldContainer}>
							<div>
								<div className={styles.fieldWrapper}>
									<div className={styles.fieldTitle}>{"First Name:"}</div>
									<div className={styles.field}>{accountInfo.firstName}</div>
								</div>
								<div className={styles.fieldWrapper}>
									<div className={styles.fieldTitle}>{"Last Name:"}</div>
									<div className={styles.field}>{accountInfo.lastName}</div>
								</div>
								<div className={styles.fieldWrapper}>
									<div className={styles.fieldTitle}>{"Phone Number:"}</div>
									<div className={styles.field}>{accountInfo.phone}</div>
								</div>
								<div className={styles.fieldWrapper}>
									<div className={styles.fieldTitle}>
										{"New Parent Account Email:"}
									</div>
									<div className={styles.field}>{accountInfo.email}</div>
								</div>
							</div>
							<div
								className={styles.edit}
								onClick={this.makeEditable}
								tabIndex={0}
							>
								Edit
							</div>
						</div>
						{acceptEl}
					</div>
				);
				buttonAction = this.props.onContinue;
			} else {
				// A continue button for if only using the form, otherwise
				// continue button is part of order summary
				const formContinueAction = this.validateOnly;
				const continueEl = formOnly ? (
					<div className={styles.button} onClick={formContinueAction}>
						Continue
					</div>
				) : null;
				content = (
					<div className={styles.form}>
						{switchTopSmall}
						{switchTop}
						{isNewAccount && firstNameEl}
						{isNewAccount && lastNameEl}
						{isNewAccount && phoneEl}

						{emailEl}
						{passwordEl}
						{repeatPasswordEl}
						{acceptEl}
						{errorEl}
						{continueEl}
					</div>
				);
			}

			const titleEl = mainTitle ? (
				<div className={styles.title}>{mainTitle}</div>
			) : null;

			const orderEl = formOnly ? null : (
				<OrderSummary
					cart={this.props.cart}
					buttonText={buttonText}
					showItemize={true}
					showError={showError}
					onContinue={buttonAction}
					tabIndex={0}
				/>
			);

			return (
				<div className={styles.main}>
					{titleEl}
					<div className={styles.across}>
						<div className={styles.formContainer}>{content}</div>
						{orderEl}
					</div>
				</div>
			);
		},
	})
);
